// extracted by mini-css-extract-plugin
export default {"headerPreview":"styles_headerPreview__PE8VA","active":"styles_active__-5m7+","container":"styles_container__S0zrk"};